/**
 * Fix Suggestion Component
 * 展示 RBAC 修复建议（Backstage 简洁风格）
 */

import React, { useState } from 'react';
import { CodeSnippet, InfoCard } from '@backstage/core-components';
import { Box, Button, Snackbar, Typography } from '@material-ui/core';
import FileCopyIcon from '@material-ui/icons/FileCopy';

interface FixSuggestionProps {
  yaml: string;
  clusterName: string;
}

export const FixSuggestion: React.FC<FixSuggestionProps> = ({ yaml, clusterName }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(yaml);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      const textArea = document.createElement('textarea');
      textArea.value = yaml;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  if (!yaml) {
    return null;
  }

  return (
    <InfoCard
      title="修复建议"
      subheader="以下 YAML 可用于补充缺失的 RBAC 权限"
      action={
        <Button
          variant="outlined"
          size="small"
          startIcon={<FileCopyIcon />}
          onClick={handleCopy}
        >
          复制
        </Button>
      }
    >
      <CodeSnippet
        text={yaml}
        language="yaml"
        showLineNumbers
        showCopyCodeButton={false}
      />
      
      <Box mt={2}>
        <Typography variant="subtitle2" gutterBottom>
          使用说明
        </Typography>
        <Typography variant="body2" component="ol" style={{ paddingLeft: 20 }}>
          <li>复制上述 YAML 内容，保存为 <code>rbac-fix-{clusterName}.yaml</code></li>
          <li>根据实际需求调整权限（可选择性移除不需要的权限）</li>
          <li>在目标集群上执行: <code>kubectl apply -f rbac-fix-{clusterName}.yaml</code></li>
          <li>重新检测以验证权限是否正确配置</li>
        </Typography>
      </Box>

      <Snackbar
        open={copied}
        autoHideDuration={2000}
        message="YAML 已复制到剪贴板"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      />
    </InfoCard>
  );
};
